export function triggerBlobDownload(blob: Blob, filename: string) {
  const objectUrl = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = objectUrl
  anchor.download = filename
  anchor.click()
  window.setTimeout(() => {
    URL.revokeObjectURL(objectUrl)
  }, 0)
}

export function parseFilenameFromContentDisposition(
  contentDisposition: string | undefined,
  fallback: string
) {
  if (!contentDisposition) {
    return fallback
  }
  const encoded = /filename\*=UTF-8''([^;]+)/i.exec(contentDisposition)
  if (encoded?.[1]) {
    try {
      return decodeURIComponent(encoded[1])
    } catch {
      return fallback
    }
  }
  const match = /filename="([^"]+)"/.exec(contentDisposition)
  if (match?.[1]) {
    return match[1]
  }
  return fallback
}
